import fs from 'node:fs'
import path from 'node:path'

export function loadEnvFile(cwd: string): void {
  const envPath = path.join(cwd, '.env.local')
  if (!fs.existsSync(envPath)) return

  const content = fs.readFileSync(envPath, 'utf-8')
  for (const line of content.split('\n')) {
    const trimmed = line.trim()
    if (!trimmed || trimmed.startsWith('#')) continue

    const eqIdx = trimmed.indexOf('=')
    if (eqIdx === -1) continue

    const key = trimmed.slice(0, eqIdx).trim()
    let value = trimmed.slice(eqIdx + 1).trim()

    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1)
    }

    const commentIdx = value.indexOf('  #')
    if (commentIdx !== -1) {
      value = value.slice(0, commentIdx).trim()
    }

    if (!process.env[key]) {
      process.env[key] = value
    }
  }
}
